/** Shared units for recorded dashboard/chat measures; never infer values from formatted strings. */
export const analyticsMetricLabels: Record<string, string> = {
    spend: 'Spend', roas: 'ROAS', purchases: 'Purchases', revenue: 'Attributed revenue',
    ctr: 'CTR', cpc: 'CPC', cpm: 'CPM', impressions: 'Impressions', clicks: 'Clicks', frequency: 'Frequency',
};
export function formatAnalyticsMetric(metric: string, value: number | null | undefined, currency = 'USD', compact = false) {
    if (value == null || !Number.isFinite(value))
        return '—';
    const notation = compact ? 'compact' as const : 'standard' as const;
    if (['spend', 'revenue', 'cpc', 'cpm', 'cpp'].includes(metric))
        return new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: compact ? 1 : 2, notation }).format(value);
    if (metric === 'roas')
        return `${value.toFixed(2)}x`;
    if (metric === 'ctr')
        return `${value.toFixed(2)}%`;
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: metric === 'frequency' ? 2 : 0, maximumFractionDigits: metric === 'frequency' ? 2 : 0, notation }).format(value);
}
